import Container from "@/app/_components/Container";
import LoadingBox from "@/app/_components/decorations/LoadingBox";

export default function SelectedClassInstanceLayout({
	children,
	isLoading = false,
	campusLocationName,
}: {
	children?: React.ReactNode;
	isLoading?: boolean;
	campusLocationName?: string;
}) {
	return (
		<Container className="flex flex-col gap-8 pb-10 pt-0 md:pb-10 md:pt-0 lg:pb-10 lg:pt-0">
			<h2 className="text-pretty text-center">
				Selected Session at{" "}
				{isLoading && !campusLocationName && (
					<LoadingBox className="inline-block h-10 w-40 rounded-full" />
				)}
				{campusLocationName && <span>{campusLocationName}</span>}
			</h2>
			<div>{isLoading ? <LoadingBox className="h-40 w-full" /> : children}</div>
		</Container>
	);
}
